import { Box, Button, Card, Checkbox, Divider, Fade, Grid, Tooltip, Typography } from "@material-ui/core"
import { isEmpty } from "lodash";
import { useCallback, useMemo } from "react";
import { usePutAlterarProcesso } from "../../../../data/api/gestao/processo-produto-setor/put-processo-produto-setor";
import { ProcessoProdutoSetorModel } from "../../../../model/api/processo-produto-setor/processo-produto-setor-model";
import { CardItemPedido } from "../card-item-pedido";
import { useStyles } from "./card-pedido-styles";
import { CircularLoading } from "../../utils";
import { Time } from "./components/timer/time";
import { EnumStatusPedido } from "../../../../model/enums/enum-status-pedido";
import { useSessaoAtual } from "../../../../services/app/providers/sessao-atual-provider";
import { useThemeQueries } from "../../../theme";
import { AdicionarRemoverProcessos } from "../../../../model/app/forms/adicionar-remover-processos/adicionar-remover-processos";
import { toDateString } from "../../../../utils/to-date";
import { PedidoEnderecoModel, PedidoModel } from "../../../../model/api/pedidos/pedido-model";
import { pegaHora } from "../../../../utils/pegar-data";
import { ProcessoProdutoSetorModelNovo } from "../../../../model/api/processo-produto-setor/put-processo-produto-setor";
import { EnumTipoPedido } from "../../../../model/enums/enum-tipo-pedido";

type Props = {
   pesquisa: string;
   filtroPesquisa: ProcessoProdutoSetorModel[];
   modelProdutos: ProcessoProdutoSetorModel[],
   processosSelecionados?: AdicionarRemoverProcessos[],
   pedido?: PedidoModel;
   onClickAtt: () => Promise<void>,
   setProcessosSelecionados: React.Dispatch<React.SetStateAction<AdicionarRemoverProcessos[]>>
}
export const CardPedido = ({
   pesquisa,
   filtroPesquisa,
   modelProdutos,
   pedido,
   processosSelecionados,
   onClickAtt,
   setProcessosSelecionados
}: Props) => {

   //AUX
   const classes = useStyles();
   const { theme } = useThemeQueries()

   const model = modelProdutos[0] ?? new ProcessoProdutoSetorModel()

   //PROVIDERS
   const { getEmpresaSelecionada } = useSessaoAtual();

   //CHAMADAS DA API
   const { putAlterarProcesso, carregando: carregandoPutProcesso } = usePutAlterarProcesso();

   const expiryTimestamp = useCallback(() => new Date(model?.systemInsertDate), [model?.systemInsertDate])
   expiryTimestamp().setSeconds(expiryTimestamp().getSeconds() + model?.minutosDePreparo * 60)

   const isCancelado = model.status.codigo === EnumStatusPedido.SolicitacaoCancelamentoAtendimento || model.status.codigo === EnumStatusPedido.Cancelado
   const isConcluido = model.status.codigo === EnumStatusPedido.Finalizado

   const alterarCorStatus = useCallback(() => {
      const horaAgora = new Date()
      if (isCancelado) {
         return theme.palette.error.main
      }
      if (horaAgora > expiryTimestamp()) {
         if (isConcluido) {
            return theme.palette.success.main
         } else if (model.minutosDePreparo !== null) {
            return theme.palette.primary.main
         }
      } else if (horaAgora < expiryTimestamp()) {
         if (isConcluido) {
            return theme.palette.success.main
         }
         return theme.palette.primary.main
      }
   }, [expiryTimestamp, isCancelado, isConcluido, model.minutosDePreparo, theme.palette.error.main, theme.palette.primary.main, theme.palette.success.main])

   const alterarTextoStatusSemMinutos = useCallback(() => {
      switch (model.status.codigo) {
         case EnumStatusPedido.AguardandoInicio:
            return 'Aguardando'
         case EnumStatusPedido.EmProducao:
            return "Produção"
         case EnumStatusPedido.AguardandoRetirada:
            return "Retirada"
         case EnumStatusPedido.EmEntrega:
            return "Entrega"
         case EnumStatusPedido.SolicitacaoCancelamentoAtendimento:
         case EnumStatusPedido.Cancelado:
            return "Cancelado"
         case EnumStatusPedido.Finalizado:
            return "Concluído"
         default:
            return ''
      }

   }, [model.status.codigo])

   const alterarCorStatusSemMinutos = useCallback(() => {
      switch (model.status.codigo) {
         case EnumStatusPedido.AguardandoInicio:
            return theme.palette.primary.main
         case EnumStatusPedido.EmProducao:
            return theme.palette.primary.main
         case EnumStatusPedido.AguardandoRetirada:
            return theme.palette.warning.main
         case EnumStatusPedido.EmEntrega:
            return theme.palette.success.main
         case EnumStatusPedido.SolicitacaoCancelamentoAtendimento:
         case EnumStatusPedido.Cancelado:
            return theme.palette.error.main
         case EnumStatusPedido.Finalizado:
            return theme.palette.success.main
         default:
            return ''
      }
   }, [model.status.codigo, theme.palette.error.main, theme.palette.primary.main, theme.palette.success.main, theme.palette.warning.main])

   const alterarTextoStatusTodosSemMinutos = useCallback(() => {
      if (model.status.codigo === EnumStatusPedido.EmProducao || model.status.codigo === EnumStatusPedido.AguardandoInicio) {
         return "AVANÇAR TODOS"
      }
      if (isConcluido) {
         return "CONCLUÍDO"
      }
      if (model.status.codigo === EnumStatusPedido.SolicitacaoCancelamentoAtendimento) {
         return "CONFIRMAR CANCELAMENTO"
      }
      return ''
   }, [isConcluido, model.status.codigo])

   const alterarTextoStatusTodos = useCallback(() => {
      const horaAgora = new Date()
      if (horaAgora < expiryTimestamp()) {
         if (isConcluido) {
            return 'Finalizado'
         } if (isCancelado) {
            return "Confirmar Cancelamento"
         }
         return "Produção"
      } else if (horaAgora === null) {
         if (isConcluido) {
            return 'Finalizado'
         } if (isCancelado) {
            return "Confirmar Cancelamento"
         }
         return "Produção"
      }

   }, [expiryTimestamp, isCancelado, isConcluido])

   const estaCancelado = useCallback(
      async (id: string[]) => {
         try {
            const novoModelo = new ProcessoProdutoSetorModelNovo(id, true)
            const ret = await putAlterarProcesso(novoModelo, getEmpresaSelecionada()?.Id || '', 9999)
            if (ret.erro) {
               throw ret.erro
            }
            await onClickAtt()
         } catch (e: any) {
            new ProcessoProdutoSetorModel()
         }
      }, [getEmpresaSelecionada, onClickAtt, putAlterarProcesso])

   const proximoWrapper = useCallback(
      async (id: string[]) => {
         try {
            const novoModelo = new ProcessoProdutoSetorModelNovo(id, false)
            let ret: any = ''
            ret = await putAlterarProcesso(novoModelo, getEmpresaSelecionada()?.Id || '', model.processoProducaoAtual + 1)

            if (ret.erro) {
               throw ret.erro
            }
            await onClickAtt()
         } catch (e: any) {
            new ProcessoProdutoSetorModel()
         }
      }, [getEmpresaSelecionada, model?.processoProducaoAtual, onClickAtt, putAlterarProcesso])

   const anteriorWrapper = useCallback(
      async (id: string[]) => {
         try {
            const novoModelo = new ProcessoProdutoSetorModelNovo(id, false)
            let ret: any = ''
            ret = await putAlterarProcesso(novoModelo, getEmpresaSelecionada()?.Id || '', model.processoProducaoAtual - 1)

            if (ret.erro) {
               throw ret.erro
            }
            await onClickAtt()
         } catch (e: any) {
            new ProcessoProdutoSetorModel()
         }
      }, [getEmpresaSelecionada, model?.processoProducaoAtual, onClickAtt, putAlterarProcesso])

   const agruparProdutosSubitens = () => {
      return modelProdutos.map(x => {

         if (x.produto?.subItens && x.produto.subItens.length > 0) {
            const inclusos = x.produto.subItens.filter(subitem => isEmpty(subitem.adicionalId));
            const adicionais = x.produto.subItens.filter(subitem => !isEmpty(subitem.adicionalId))
            return {
               ...x,
               produto: {
                  ...x.produto,
                  adicionais: adicionais,
                  inclusos: inclusos,
               }
            }
         }

         return {
            ...x,
            produto: {
               ...x.produto,
               adicionais: [],
               inclusos: [],
            }
         }
      })
   }

   const produtos = agruparProdutosSubitens()

   const adicionarRemoverProcessos = useCallback(() => {
      const selecionados = processosSelecionados?.filter(x => produtos.filter(y => y.id === x.produtoId));
      const isProdsSelecionados = selecionados?.filter(x => {
         return produtos.some(y => y.id === x.produtoId);
      });
      const isProdsDiferentesSelecionados = selecionados?.filter(x => {
         return produtos.every(y => y.id !== x.produtoId);
      });


      if (isEmpty(selecionados)) {
         const select = [...produtos.map(x => ({
            produtoId: x.id,
            pedidoId: x.pedidoId,
            groupId: x.produto.groupId,
            codigoReferencia: x.produto.codigoReferencia,
         }))]

         return setProcessosSelecionados(prev => [...prev, ...select]);
      }
      else if (isProdsSelecionados?.length! > 0) {
         return setProcessosSelecionados(isProdsDiferentesSelecionados!);
      }
      else {
         const select = [...produtos.map(x => ({
            produtoId: x.id,
            pedidoId: x.pedidoId,
            groupId: x.produto.groupId,
            codigoReferencia: x.produto.codigoReferencia,
         }))]

         return setProcessosSelecionados(prev => [...prev, ...select]);
      }

   }, [processosSelecionados, produtos, setProcessosSelecionados])

   const retornaEndereco = useMemo(() => {
      const { bairro, municipio, numero, complemento, logradouro, uf } = pedido?.enderecoEntrega ?? new PedidoEnderecoModel()

      if (isEmpty(pedido?.enderecoEntrega)) {
         return ''
      }

      return `${logradouro ?? ''}, ${numero ?? 0} - ${bairro ?? ''}${municipio ? `, ${municipio}` : ''}${uf ? ` - ${uf}` : ''}${complemento ? `, ${complemento}` : ''}`
   }, [pedido?.enderecoEntrega])

   const retIdentificador = () => {
      if (!isEmpty(model.identificador)) return model.identificador;
      if (!isEmpty(model.cliente)) return model.cliente;

      return 'Consumidor'
   }

   // Função para verificar o tipo do pedido, se for ENTREGA ou RETIRADA e estar no processo de AguardandoRetirada, 
   // irá sumir a opção de selecionar o produto sozinho
   const esconderCheckboxSeRetiradaOuEntrega = useCallback(() => {
      if (model.status.codigo === EnumStatusPedido.AguardandoRetirada) {
         if (!pedido) return false
         if (pedido?.tipoPedido.codigo !== EnumTipoPedido.LOCAL) {
            return true
         }
      }
      return false
   }, [model.status.codigo, pedido])


   /**
    * Verifica se todos os itens do pedido (que possuem setor e não são taxas)
    * estão presentes na lista de processos renderizados no card.
    * 
    * Objetivo: Garantir que, para pedidos de Retirada ou Entrega em status de "Aguardando Retirada",
    * a seleção/ação só esteja disponível se todos os itens pertinentes estiverem visíveis/carregados.
    */
   const verificarProdutosPedidoRetiradaOuEntrega = useCallback(() => {
      // Se não precisa validar (não é retirada/entrega ou status diferente), retorna true permitindo a ação.
      if (!esconderCheckboxSeRetiradaOuEntrega()) {
         return true;
      }

      const listaProdutosPedido = pedido?.produtos || [];

      // Filtra apenas produtos que devem ser validados:
      // 1. Possuem setor vinculado (setorId)
      // 2. Não são "TAXA DE ENTREGA"
      const produtosRelevantesDoPedido = listaProdutosPedido.filter(prod => {
         const possuiSetor = !!prod.setorId;
         const ehTaxaEntrega = prod.descricao === 'TAXA DE ENTREGA';
         return possuiSetor && !ehTaxaEntrega;
      });

      // Verifica se cada produto relevante do pedido existe na lista de processos (produtos) deste card.
      // Utiliza 'codigoReferencia' como chave de ligação entre o item do pedido e o processo no KDS.
      const todosProdutosEstaoPresentes = produtosRelevantesDoPedido.every(itemPedido =>
         produtos.some(processoKds => processoKds.produto.codigoReferencia === itemPedido.codigoReferencia)
      );

      return todosProdutosEstaoPresentes;
   }, [esconderCheckboxSeRetiradaOuEntrega, pedido?.produtos, produtos])

   const todosOsPedidosSelecionados = (() => {
      const produtosSize = produtos.length
      if (produtosSize < 1) return false
      const processosPedido = processosSelecionados?.filter(x => produtos[0] && x.pedidoId === produtos[0].pedidoId)

      return processosPedido && produtosSize <= processosPedido.length
   })()

   return (
      <>
         {(!isEmpty(pesquisa) ? filtroPesquisa.length > 0 : isEmpty(filtroPesquisa)) && (
            <>
               {carregandoPutProcesso && <CircularLoading tipo="FULLSIZED" />}
               <Fade in>
                  <Card className={classes.cardContainer}>
                     <Grid container spacing={2}>
                        <Grid item xs={12}>
                           <Grid container spacing={1} className={classes.labelTop} style={{ marginBottom: '0px' }}>
                              <Grid item xs={7}>
                                 <Box display={"flex"} flexWrap="wrap" alignItems={"center"}>
                                    {isEmpty(model.mesaCodigo) && isEmpty(model.comandaCodigo) && (
                                       <Typography
                                          variant="body2"
                                          color="textPrimary"
                                       >
                                          Pedido <b>#{model.codigoPedido}</b>
                                       </Typography>
                                    )}
                                    {!isEmpty(model.mesaCodigo) && (
                                       <Typography
                                          variant="body2"
                                          color="textPrimary"
                                       >
                                          Mesa <Box component="span" fontWeight={700} fontSize={theme.typography.pxToRem(18)}>{model.mesaCodigo}</Box>
                                       </Typography>
                                    )}
                                    {!isEmpty(model.comandaCodigo) && !isEmpty(model.mesaCodigo) && (
                                       <Typography
                                          variant="body2"
                                          color="textPrimary"
                                          style={{
                                             padding: theme.spacing(0, 1),
                                          }}
                                       >
                                          /
                                       </Typography>
                                    )}
                                    {!isEmpty(model.comandaCodigo) && (
                                       <>
                                          <Typography
                                             variant="body2"
                                             color="textPrimary"
                                          >
                                             Comanda <Box component="span" fontWeight={700} fontSize={theme.typography.pxToRem(18)}>{model.comandaCodigo}</Box>
                                          </Typography>
                                       </>
                                    )}
                                 </Box>
                              </Grid>
                              <Grid item xs={5}>
                                 <Box display={"flex"} alignItems="center" justifyContent={"flex-end"}>
                                    <Tooltip title="Data de Inserção" placement="top" arrow>
                                       <Box pl={1}>
                                          <Typography
                                             variant="caption"
                                             className={classes.insertDate}
                                             style={{
                                                color: (model.minutosDePreparo !== 0) ?
                                                   alterarCorStatus() : alterarCorStatusSemMinutos()
                                             }}
                                          >
                                             {toDateString(new Date(model.systemInsertDate))} - {pegaHora(model.systemInsertDate)}
                                          </Typography>
                                       </Box>
                                    </Tooltip>
                                 </Box>
                              </Grid>
                              <Grid item xs={7} className={classes.labelDiv} >
                                 <Typography
                                    variant="body1"
                                    color="textPrimary"
                                    style={{
                                       display: 'flex',
                                       alignItems: 'center'
                                    }}
                                 >
                                    <Box fontWeight={600}>
                                       {retIdentificador()}
                                    </Box>
                                 </Typography>
                              </Grid>
                              <Grid item xs={5} style={{
                                 display: 'flex',
                                 justifyContent: 'flex-end',
                                 alignItems: 'center'
                              }}>
                                 <Box>
                                    <Typography
                                       variant="caption"
                                       className={classes.statusLabel}
                                       style={{
                                          backgroundColor: (model.minutosDePreparo !== 0) ?
                                             alterarCorStatus() : alterarCorStatusSemMinutos()
                                       }}
                                    >
                                       {alterarTextoStatusSemMinutos()}
                                    </Typography>
                                 </Box>
                              </Grid>

                              {!isEmpty(pedido?.enderecoEntrega?.logradouro) &&
                                 <Grid item xs={12}>
                                    <Typography
                                       variant="body2"
                                       color="textPrimary"
                                    >
                                       {retornaEndereco}
                                    </Typography>
                                 </Grid>
                              }

                              <Grid item xs={12}>
                                 <Divider
                                    variant="fullWidth"
                                    style={{
                                       background: theme.palette.grey[300]
                                    }}
                                 />
                              </Grid>
                           </Grid>
                        </Grid>

                        <Grid item xs={12}>
                           {produtos.map(item => {
                              return (
                                 <>
                                    <Fade in>
                                       <CardItemPedido
                                          model={item}
                                          proximo={async (valor) => await proximoWrapper(valor)}
                                          anterior={async (valor) => await anteriorWrapper(valor)}
                                          estaCancelado={async (valor) => await estaCancelado(valor)}
                                          processosSelecionados={processosSelecionados!}
                                          setProcessosSelecionados={setProcessosSelecionados}
                                          esconderCheckboxSeRetiradaOuEntrega={esconderCheckboxSeRetiradaOuEntrega}
                                       />
                                    </Fade>
                                 </>
                              )
                           })}
                        </Grid>

                        <Grid item xs={12}>
                           <Box>
                              {(model.status.codigo < EnumStatusPedido.Finalizado) ? (
                                 <>
                                    <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                       {modelProdutos.length > 1 && (
                                          <Grid item xs={true}>
                                             <Button
                                                style={{ backgroundColor: alterarCorStatus() }}
                                                onClick={async () => await proximoWrapper(modelProdutos.map(item => item.id))}
                                                variant="contained"
                                                color="primary"
                                                size="medium"
                                                fullWidth
                                             >
                                                {!isEmpty(model.minutosDePreparo !== 0) ? alterarTextoStatusTodos() : alterarTextoStatusTodosSemMinutos()}
                                             </Button>
                                          </Grid>
                                       )}

                                       <Grid item xs={'auto'}>
                                          <Time
                                             inserted={new Date(model.systemUpdateDate)}
                                             range={model.minutosDePreparo}
                                          />
                                       </Grid>
                                    </Grid>
                                 </>
                              ) : (model.status.codigo === EnumStatusPedido.SolicitacaoCancelamentoAtendimento) && (
                                 <>
                                    <Button
                                       style={{ backgroundColor: alterarCorStatus() }}
                                       onClick={async () => await estaCancelado(modelProdutos.map(item => item.id))}
                                       variant="contained"
                                       color="primary"
                                       fullWidth
                                       size="medium"
                                    >
                                       {!isEmpty(model.minutosDePreparo !== 0) ? alterarTextoStatusTodos() : alterarTextoStatusTodosSemMinutos()}
                                    </Button>
                                 </>
                              )}

                              {verificarProdutosPedidoRetiradaOuEntrega() && model.status.codigo === EnumStatusPedido.AguardandoRetirada && (
                                 <Grid item xs={12}>
                                    <Button
                                       variant="outlined"
                                       size="medium"
                                       onClick={adicionarRemoverProcessos}
                                       color={todosOsPedidosSelecionados ? "primary" : "default"}
                                       fullWidth
                                    >
                                       <Checkbox
                                          color="primary"
                                          checked={todosOsPedidosSelecionados}
                                       />
                                       {pedido?.tipoPedido.codigo !== EnumTipoPedido.LOCAL ? 'Selecionar pedido' : 'Selecionar Todos'}
                                    </Button>
                                 </Grid>
                              )}
                              {!verificarProdutosPedidoRetiradaOuEntrega() && (
                                 <Typography color="textPrimary" variant="body2" align="center">
                                    Aguardando todos os produtos deste pedido
                                 </Typography>
                              )}
                              {/* TODO: Não está mostrando o botão porque não há pedido refletindo no modelo. */}
                              {model.status.codigo === EnumStatusPedido.Finalizado && (model.tipoPedido === EnumTipoPedido.ENTREGA || model.tipoPedido === EnumTipoPedido.RETIRAR) && (
                                 <Grid item xs={12}>
                                    <Button
                                       variant="outlined"
                                       size="small"
                                       onClick={adicionarRemoverProcessos}
                                       color={todosOsPedidosSelecionados ? "primary" : "default"}
                                       fullWidth
                                    >
                                       Visualizar Assinatura
                                    </Button>
                                 </Grid>
                              )}
                           </Box>
                        </Grid>
                     </Grid>
                  </Card>
               </Fade>
            </>
         )}
      </>
   )
}